import { registerWidgetAction } from "@luxalgo/vela";
import { registerIcon, svg16 } from "@luxalgo/vela/ui";

/** DOM event a chart host listens for to toggle full page. */
export const TESSERA_VELA_FULL_PAGE_EVENT = "tessera-vela-full-page";

const ICON_ID = "tessera-full-page";
let registered = false;

/**
 * "Full page" button in every Vela chart's top toolbar. Vela's widget actions are global, so
 * the click is routed to its own chart: an event on the nearest `.tessera-vela-host`, which
 * that chart's React component turns into a viewport-filling overlay (Esc / the button closes).
 * Call before a workspace is constructed.
 */
export function ensureTesseraVelaFullPageAction(): void {
  if (registered) return;
  registered = true;
  try {
    registerIcon(
      ICON_ID,
      svg16(
        '<path d="M2 6V2h4M10 2h4v4M14 10v4h-4M6 14H2v-4" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>'
      )
    );
    registerWidgetAction({
      id: "tessera-full-page",
      target: "topbar",
      label: "Full page",
      icon: ICON_ID,
      iconOnly: true,
      order: 100,
      run: (ctx) => {
        const host = ctx.host?.closest?.(".tessera-vela-host");
        host?.dispatchEvent(new CustomEvent(TESSERA_VELA_FULL_PAGE_EVENT));
      },
    });
  } catch {
    // Older Vela without widget actions — no button, chart unaffected.
    registered = false;
  }
}
